import { lazy } from 'react';
import Calendar from './Calendar';
import Dashboard from './Dashboard'
// import RequestList from './RequestList';
import RequestType from './RequestType';
// import Thankyou from './Thankyou';

const DesignStudioListConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/design-studio-dashboard',
            element: <Dashboard />,
        },
        {
            path: '/design-studio/new-request',
            element: <RequestType />,
        },
        {
            path: '/new-request-calendar',
            element: <Calendar />,
        },
        // {
        //     path: '/thank-you',
        //     element: <Thankyou />,
        // },
        // {
        //     path: '/request-list',
        //     element: <RequestList />,
        // },
    ],
};

export default DesignStudioListConfig;
